import { ArrowDownwardRounded, ArrowUpwardRounded } from '@mui/icons-material';
import {
    Box,
    Button,
    IconButton,
    InputBase,
    MenuItem,
    Select,
} from '@mui/material';
import SimpleSelect from './SimpleSelect';

const SimpleSort = ({
    sortOptions = [],
    sortField,
    sortOrder,
    toggleDirection,
    setSortField,
}) => {
    return (
        <Box>
            <SimpleSelect
                options={sortOptions}
                value={sortField}
                onChange={e => setSortField(e.target.value)}
            />
            <IconButton onClick={toggleDirection}>
                {sortOrder === 'asc' ? (
                    <ArrowUpwardRounded fontSize="small" />
                ) : (
                    <ArrowDownwardRounded fontSize="small" />
                )}
            </IconButton>
        </Box>
    );
};

export default SimpleSort;
